// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"185e95f9","453":"720d1b3e"}[chunkId] + ".chunk.js";
};